/** Shared shape helpers for the flag drafts held in the time report form. */

export const FLAG_TYPES = {
  DEVIATION: "deviation",
  MISSING_TASK: "missing_task",
  ATA: "ata",
};

export const FLAG_SEVERITIES = ["low", "medium", "blocking"];

let draftCounter = 0;

export function createDraft(type, overrides = {}) {
  draftCounter += 1;
  return {
    localId: `draft-${draftCounter}`,
    type,
    description: "",
    severity: "medium",
    hoursImpact: "",
    linkedTaskKey: "",
    proposedTaskName: "",
    hours: "",
    photos: [],
    ...overrides,
  };
}

/** Stable key for the "which task?" select, since entries have no id of their own. */
export function taskEntryKey(entry) {
  if (!entry?.taskId) return "";
  return `${entry.taskId}:${entry.subtaskId || ""}`;
}

export function findEntryByKey(entries, key) {
  if (!key) return null;
  return entries.find((entry) => taskEntryKey(entry) === key) || null;
}

/** Serialise drafts for the `flags` part of the report submission. */
export function serialiseDrafts(drafts, taskEntries) {
  return drafts.map((draft) => {
    const linked = findEntryByKey(taskEntries, draft.linkedTaskKey);
    return {
      type: draft.type,
      description: draft.description || "",
      severity: draft.severity,
      hoursImpact: draft.hoursImpact || undefined,
      proposedTaskName: draft.proposedTaskName || undefined,
      hours: draft.hours || undefined,
      linkedTask: linked
        ? {
            bundleId: linked.bundleId,
            taskId: linked.taskId,
            subtaskId: linked.subtaskId || undefined,
          }
        : undefined,
    };
  });
}

/** Append each draft's photos under the indexed field name the server expects. */
export function appendDraftPhotos(formData, drafts) {
  drafts.forEach((draft, index) => {
    (draft.photos || []).forEach((photo) => {
      formData.append(`flagPhotos_${index}`, photo);
    });
  });
}

export function isDraftValid(draft) {
  if (!draft) return false;
  if (draft.type === FLAG_TYPES.MISSING_TASK) {
    return !!String(draft.proposedTaskName || "").trim();
  }
  return !!String(draft.description || "").trim();
}
